import { AppLogo } from '@hawkins/components';

export const HomeLogo = () => {
  return (
    <AppLogo
      studioLogo
      href="/"
      name="Portal"
    />
  );
};